import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/index.js';
import { router } from './app/router.js';

/**
 * App root: monta l'AuthProvider attorno al router così che `useAuth` sia disponibile a
 * TUTTE le route, anche in deep-link diretto a pagine gated (/tickets, /enisa-reports, /admin).
 * Il QueryClientProvider è montato in main.tsx (sopra questo componente).
 */
function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
